import { useMutation } from "react-query";
import http from "infra/http";
import { PastaForm, UseSavePastaProps } from "../typings";

function useSavePasta({ id }: UseSavePastaProps) {
  return useMutation(
    (data: PastaForm) => {
      if (id) {
        return http.put(`/v1/documento/pastas/${id}`, data);
      }

      return http.post(`/v1/documento/pastas`, data);
    },
    { retry: false }
  );
}

export default useSavePasta;
